var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    d: "M0,192L30,170.7C60,149,120,107,180,80C240,53,300,43,360,58.7C420,75,480,117,540,117.3C600,117,660,75,720,53.3C780,32,840,32,900,53.3C960,75,1020,117,1080,133.3C1140,149,1200,139,1260,112C1320,85,1380,43,1410,21.3L1440,0L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.538f00c117f72ae07e29ad754c8da5aa.svg";
export { ForwardRef as ReactComponent };